import { axiosInstance } from "../config/axiosConfig";
import { LOGIN } from "../config/endpoint";
import loaderService from "./loaderService";
import { showError } from "./toastService";

export const login = (formData) => {
    loaderService.show();
    axiosInstance.post(LOGIN, formData)
        .then(res => {
            localStorage.setItem('userInfo', JSON.stringify(res.user || {}))
            localStorage.setItem('token', res.token)
            window.location.href = '/';
        })
        .catch(err => {
            showError(err?.response?.data?.message)
        }).finally(() => {
            loaderService.hide();
        });
}

export const logout = () => {
    localStorage.clear();
    window.location.href = '/';
}